import OutlinedInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select, { type SelectChangeEvent } from '@mui/material/Select'
import MunicipalitiesLoader from '@/wrappers/municipalities-loader'

export default function MunicipalitySelector({
    municipalityId,
    setMunicipalityId,
}: {
    municipalityId,
    setMunicipalityId,
}) {

    return (
        <MunicipalitiesLoader>
            {municipalities => (
                <FormControl sx={{ minWidth: 190, flexGrow: 1 }}>
                    <InputLabel id="municipality-select-label" size='small'>Obec</InputLabel>
                    <Select
                        labelId="municipality-select-label"
                        label="Obec"
                        id="roles-select"
                        value={municipalityId}
                        onChange={(e: SelectChangeEvent) => {
                            setMunicipalityId(e.target.value)
                        }}
                        input={<OutlinedInput label="Obec" />}
                        size='small'
                    >
                        <MenuItem key="none" value="">-</MenuItem>
                        {municipalities.sort((a, b) => a.name.localeCompare(b.name, 'cs', { numeric: true })).map(municipality => (
                            <MenuItem key={municipality.id} value={municipality.id}>{municipality.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        </MunicipalitiesLoader>
    )
}
